import React, { Component } from "react";
//import { Helmet } from 'react-helmet';
const zendeskKey = process.env.REACT_APP_ZENDESK_KEY
// console.log('zendeskKey', zendeskKey)
class Support extends Component {
    constructor(props){
		super(props);
	}
    render() {		 		
        return (
        	<div className="ProducerSaveDate AddStoryBoard">
				 
					{/* <!-- Start of associationstudios Zendesk Widget script --> */}
					<script id="ze-snippet" src={`https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`}> </script>
					{/* <!-- End of associationstudios Zendesk Widget script -->			 */}	
				
					<h3>Support Page</h3>
			</div>	
		);
    }
}
export default Support;